import Structor from "../util/structor_2"

export default class HydratedUnit extends Structor {
  defineStruct() {
    return {
      id: null,
      startIndex: null,
      endIndex: null,
      isMoving: false,
      depth: null,
      startDate: null,
      endDate: null,
      ancestorIds: [],
      descendantIds: [],
      unitLength: null,
      contextMenuIsOpen: false,
    }
  }
}
